export default {
  ZERO_WIDTH: 0,
  PAD_WIDTH: 768,
};
